exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-part[data-v-54a6d310] {\n  width: 100%;\n  height: 0.640625rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 0.208333rem 0 0.15625rem;\n  font-size: 0.125rem;\n  color: #fff;\n}\n.logo-icon-cls[data-v-54a6d310] {\n  width: 0.703125rem;\n}", ""]);

// exports
